import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
    textAlign: 'center',
  },
  activeStatus: {
    color: theme.palette.success.main,
    textTransform: 'capitalize',

    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
  searchIcon: {
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(14),
    },
  },
  status: {
    paddingLeft: '10px',
    position: 'relative',
    '&::before': {
      content: "''",
      position: 'absolute',
      width: 5,
      height: 5,
      borderRadius: '50%',
      bottom: '5px',
      backgroundColor: theme.palette.grey[500],
    },
    '& .status': {
      textTransform: 'capitalize',
      marginLeft: '10px',
    },
  },
  active: {
    '&::before': {
      backgroundColor: theme.palette.success.main,
    },
  },
}));

export default useStyles;
